// Routeur multi-jeux pour room configs.
import { getOrigamiRoomInfo } from "./origami/roomConfig";

// Convention: gameId = number (1 = Origami, etc.)
export function getRoomInfo(gameId, stage, variant) {
  switch (Number(gameId)) {
    case 1:
      return getOrigamiRoomInfo(stage, variant);

    default:
      return {
        id: "UNKNOWN",
        label: "Zone inconnue",
        icon: null,
        activity: "Déplacement en cours…",
      };
  }
}
